export default __webpack_public_path__ + "static/media/layout-1.971a52c6.jpg";